import React from "react";
import AudioSquareTag from "./AudioSquareTag";
import "./styles.scss";
import { ReactComponent as DeleteMediaIcon } from "../../../../public/delete-artist.svg";

export default (props) => {
  const { medium, mediumSetter, className, onClick, showActions, x } = props;
  const renderMedia = () => {
    switch (medium.type) {
      case "SoundTrack":
        return <AudioSquareTag medium={medium} />;
      case "Image":
        return (
          <div className="card-body image-tag">
            <img className="img-fluid" src={medium.url} alt="medium" />
          </div>
        );
      case "Video":
        return (
          <div className="card-body video-tag">
            <video src={medium.url} className="w-100" />
          </div>
        );
      default:
        return null;
    }
  };
  const onX = () => x(medium);
  return (
    <div className={`media-square-tag card ${className}`}>
      {x && <DeleteMediaIcon className="remove-medium" onClick={onX} />}
      {renderMedia()}
    </div>
  );
};
